// Number to Words Tool — convert numbers to written English words.
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const numberToWordsTool: Tool = {
  id: "number-to-words",
  name: () => m.nw_tool_name(),
  description: () => m.nw_tool_description(),
  icon: "🔢",
  basePath: "/number-to-words",
  status: "stable",
  tags: ["number", "words", "spelling", "converter"],
  pages: [
    {
      name: () => m.nw_nav_main(),
      path: "/number-to-words",
      description: () => m.nw_nav_main_desc(),
      icon: "🔢",
    },
  ],
};
